module.exports = __webpack_public_path__ + "img/pen.e599525d.gif";